export function BrandMark({ className = "h-10 w-10" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <rect width="64" height="64" rx="18" fill="#111315" />
      <path d="M18 39V25c0-5 4-9 9-9h10c5 0 9 4 9 9v14c0 5-4 9-9 9H27c-5 0-9-4-9-9Z" fill="#FBF9F5" />
      <path d="M26 32c0-3.3 2.7-6 6-6s6 2.7 6 6-2.7 6-6 6-6-2.7-6-6Z" fill="#D97706" />
      <path d="M42 16h8v8" stroke="#D97706" strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
}

export function BrandLogo({ dark = false }) {
  return (
    <span className="flex items-center gap-3">
      <BrandMark />
      <span className="leading-none">
        <span className={`block font-heading text-lg font-extrabold tracking-tight ${dark ? "text-white" : "text-[#111315]"}`}>Operandi</span>
        <span className="block font-mono text-[10px] uppercase tracking-[0.28em] text-amber-700">Studio</span>
      </span>
    </span>
  );
}
